import { connect, MapStateToProps } from 'react-redux';
import {
  getIsLoggedIn,
  getCartCount,
  getCanUserSeeWatch,
  getCurrentUserHasCore,
} from '../../publicSession/selectors';
import { getChatUnreadCount } from '../../Chat/redux/selectors';
import { Props } from './SiteHeaderDesktop';

export type StateProps = Pick<
  Props,
  | 'hasCoreMembership'
  | 'isLoggedIn'
  | 'chatCount'
  | 'cartCount'
  | 'canSeeOldWatch'
>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => ({
  hasCoreMembership: getCurrentUserHasCore(state),
  chatCount: getChatUnreadCount(state),
  isLoggedIn: getIsLoggedIn(state),
  cartCount: getCartCount(state),
  canSeeOldWatch: getCanUserSeeWatch(state),
});

export default connect(mapStateToProps);
